import {DialogueMenubarProps} from './types'
import DialogueMenubarView from './DialogueMenubarView'
import React from 'react'
import {confirmationModal} from '../../../actions/modal'
import {useAppDispatch} from '../../../hooks'
import {useTranslation} from 'react-i18next'

const DialogueMenubar = (props: DialogueMenubarProps): React.ReactElement => {
    const {
        chat,
        isChannelSidebarOpen,
        onToggleChannelSidebar,
    } = props

    const dispatch = useAppDispatch()

    const {t} = useTranslation()

    const onHide = (dialogue_id: string) => {
        dispatch(confirmationModal({
            onConfirm: {
                action: 'hideDialogue',
                dialogueId: dialogue_id,
            },
            show: true,
            text: t('Are you sure you wish hide this conversation?'),
            title: t('Hide conversation?'),
        }))
    }

    return (
        <DialogueMenubarView
            chat={chat}
            isChannelSidebarOpen={isChannelSidebarOpen}
            onHide={onHide}
            onToggleChannelSidebar={onToggleChannelSidebar}
        />
    )
}

export default DialogueMenubar
